import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchNaturalPersonTitles } from "../api/naturalPersonService";
import { fetchLegalPersonTitles } from "../api/legalPersonService";
/** react-query key prefix of the "Uvedeno u titulů" person detail section. */
export var PERSON_TITLES_QUERY_KEY = "personTitles";
/**
 * Titles in which a natural / legal person appears as a title contribution
 * (person detail section "Uvedeno u titulů", DB-635).
 *
 * @param kind natural or legal person
 * @param personId the person; the query is disabled without it
 */
export var usePersonTitles = function (kind, personId) {
    var ky = useOkapiKy();
    return useQuery([PERSON_TITLES_QUERY_KEY, kind, personId], function () {
        return kind === "natural"
            ? fetchNaturalPersonTitles(ky, personId)
            : fetchLegalPersonTitles(ky, personId);
    }, { enabled: !!personId, refetchOnWindowFocus: false });
};
